// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2579) return "static/chunks/2579-053d7eb9eabf26ff.js";
	if (chunkId === 2174) return "static/chunks/2174-5df031c252cc01f5.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1814":"9549e33d1661a6b0","4246":"35ac27c3665c1dd4","4438":"79a558c8cbfe3e5b","6981":"8b4f1a0e76f7e7fd"}[chunkId] + ".js";
};